import { useState } from "react";
import { MdOutlineAccountCircle } from "react-icons/md";
import styles from "./UserProfileIcon.module.css";

const UserProfileIcon = ({ user, onClick }) => {
    const [showModal, setShowModal] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleMouseEnter = () => {
        setShowModal(true);
        setIsAnimating(true);
    };

    const handleMouseLeave = () => {
        setIsAnimating(false);
        setTimeout(() => {
            if (!isAnimating) setShowModal(false);
        }, 300);
    };

    return (
        <div 
            className={styles.userSection} 
            onClick={onClick}
        >
            <MdOutlineAccountCircle 
                size={30}
                className={styles.userIcon}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            />
            {showModal && (
                <div className={`${styles.userProfileModal} ${isAnimating ? styles.fadeIn : styles.fadeOut}`}>
                    <div className={styles.userProfileInfo}>
                        <div className={styles.userName}>{user?.name || user?.nome || 'Não autenticado'}</div>
                        <hr className={styles.userProfileDivider} />
                        {(user?.grupoPermissao || user?.permissionGroup) && (
                                <div className={styles.userPermission}>{user?.grupoPermissao || user?.permissionGroup}</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserProfileIcon;
